<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    import { Tooltip, tooltip } from '@svelte-plugins/tooltips';
    import src from './svg/job_loaded.svg';
    import { _ } from 'svelte-i18n';
    import { app } from '../../../stores/app';

    export let loaded: {time: number, scanned: boolean} | undefined;
    export let scale: number = 0.7;

    let content: string = '';
    let showWithTooltip: boolean = true;

    $: {
        if (loaded) {
            content = '<div style="font-style: italic; font-size: 80%;">'+$_('Job loaded')+':</div><div>'+(new Date(loaded.time * 1000)).toLocaleString()+'</div>';
        } else {
            content = '';
        }
        showWithTooltip = false;
        setTimeout(() => showWithTooltip = true, 0);
    }
</script>

{#if showWithTooltip}
<div use:tooltip={{content: content, theme: 'lastmile-tooltip'}}>
    <TemplateIcon {src} alt="Note added" scale={(scale*0.9)}/>
</div>
{:else}
<div>
    <TemplateIcon {src} alt="Note added" scale={scale*0.9}/>
</div>
{/if}

<style>
    :global(.tooltip.lastmile-tooltip) {
        --tooltip-color: #000000;
        --tooltip-background-color: #f5f5f5;
    }
    :global(.tooltip.lastmile-tooltip-no-events) {
        --tooltip-color: #000000;
        --tooltip-background-color: #f5f5f5;
    }
</style>
